import { render, staticRenderFns } from "./Penthouse.vue?vue&type=template&id=8c501f3a&scoped=true&"
import script from "./Penthouse.vue?vue&type=script&lang=js&"
export * from "./Penthouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c501f3a",
  null
  
)

export default component.exports